export { default } from "./CategoryPageLayout.jsx";
